import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import Login from './components/Login';
import FoundItemRegistration from './components/FoundItemRegistration';
import FoundItemList from './components/FoundItemList';
import FoundItemDetails from './components/FoundItemDetails';
import LostItemRegistration from './components/LostItemRegistration';
import LostItemDetails from './components/LostItemDetails';
import MatchDetails from './components/MatchDetails';
import AdminDashboard from './components/AdminDashboard';
import Navigation from './components/Navigation';
import HotelValidationWrapper from './components/HotelValidationWrapper';
import VersionFooter from './components/VersionFooter';
import UserSettingsPage from './pages/UserSettingsPage';
import ShippingSettingsPage from './pages/ShippingSettingsPage';
import ShippingStatusPage from './pages/ShippingStatusPage';
import LandingPage from './pages/LandingPage';
import TokushohoPage from './pages/legal/TokushohoPage';
import PrivacyPage from './pages/legal/PrivacyPage';
import TermsPage from './pages/legal/TermsPage';
import './App.css';
import './styles/app.css';

// Component to render routes within a hotel context
function HotelRoutes() {
  // Potentially use useParams here if needed at this level
  // const { hotelId } = useParams(); 
  return (
    <div className="container">
      <Routes>
        {/* Routes that ARE hotel-specific */}
        <Route 
          path="/admin" 
          element={
            <div className="container admin-container">
              <PrivateRoute>
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              </PrivateRoute>
            </div>
          } 
        />
        <Route path="/report-lost-item" element={<LostItemRegistration />} />
        <Route 
          path="/found-items/register" 
          element={
            <PrivateRoute>
              <FoundItemRegistration />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/found-items" 
          element={
            <PrivateRoute>
              <AdminRoute>
                <FoundItemList />
              </AdminRoute>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/found-items/:id" 
          element={
            <PrivateRoute>
              <FoundItemDetails />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/lost-items/:id" 
          element={
            <LostItemDetails />
          }
        />
        <Route 
          path="/matches/:id" 
          element={
            <MatchDetails />
          } 
        />
         {/* Redirect base hotel path to admin? Or a dashboard? */}
        <Route 
          path="/" 
          element={
             <Navigate to="admin" replace /> 
          } 
        />
        <Route
          path="settings"
          element={
            <PrivateRoute>
              <AdminRoute>
                <UserSettingsPage />
              </AdminRoute>
            </PrivateRoute>
          }
        />
      </Routes>
    </div>
  );
}

function App() {
  // const defaultHotelId = "main"; // No longer needed for root redirect

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          {/* Navigation might need hotelId awareness later */}
          <Navigation /> 
          <Routes>
            {/* Routes that are NOT hotel-specific */}
          <Route path="/login" element={
            <div className="container"><Login /></div>
          } />

            <Route
              path="/shipping-settings"
              element={
                <PrivateRoute>
                  <ShippingSettingsPage />
                </PrivateRoute>
              }
            />

            <Route
              path="/shipping-status"
              element={
                <PrivateRoute>
                  <ShippingStatusPage />
                </PrivateRoute>
              }
            />

            {/* Legal pages (must not be swallowed by /:hotelId/*) */}
            <Route path="/tokushoho" element={<TokushohoPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />

            {/* Hotel specific routes nested under :hotelId */}
            <Route path="/:hotelId/*" element={<HotelValidationWrapper><HotelRoutes /></HotelValidationWrapper>} />

            {/* Landing page for the root path (falls back to HotelSelector for signed-in staff) */}
            <Route
              path="/"
              element={<LandingPage />}
            />
            
             {/* Optional: Catch-all for non-matching routes */}
            <Route path="*" element={<div>Not Found</div>} />
          </Routes>
          <VersionFooter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
